import { onSnapshot, orderBy, query } from 'firebase/firestore';
import { get } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

import signalsRef from '...data/signals/collections/signals';
import { testKeyId } from '...data/test';

const dfend = window.DFend(testKeyId);

const colors = {
  cell: '#f5f5f5',
  critical: '#cc3300',
  warning: '#ffcc00',
  normal: '#339900'
};

const App = () => {
  const [signals, setSignals] = useState([]);

  const push = async () => {
    const signal = {
      identifiers: {
        email: 'test@test.com'
      },
      metadata: {
        demo: true
      }
    };
    const result = await dfend.push(signal);
    console.log(result);
  };

  useEffect(() => {
    const q = query(signalsRef, orderBy('_m.c', 'desc'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const _signals = [];
      querySnapshot.forEach((doc) => {
        _signals.push({ id: doc.id, ...doc.data() });
      });
      console.log('SIGNALS', _signals);
      setSignals(_signals);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div style={{ fontFamily: 'sans-serif' }}>
      <h3>Signals Count</h3>
      <h1>{signals.length}</h1>
      <button onClick={push}>Push signal for user: test@test.com</button>
      <h3>Signals</h3>
      <table>
        <thead>
          <tr>
            <th>Type</th>
            <th>IP</th>
            <th>Country</th>
            <th>Time</th>
            <th>Impossible Travel</th>
            <th>IP Similarity</th>
          </tr>
        </thead>
        <tbody>
          {signals.map(signal => {
            const hasImpossibleTravel = signal.immediateResults?.find(r => get(r, 'type') === 'ImpossibleTravel');
            const hasIpSimilarity = signal.immediateResults?.find(r => get(r, 'type') === 'IpSimilarity');
            return (
              <tr key={signal.id}>
                <td style={{ background: colors.cell, padding: '4px 8px', margin: '2px' }}>{signal.data.type}</td>
                <td style={{ background: colors.cell, padding: '4px 8px', margin: '2px' }}>{signal.data.ip}</td>
                <td style={{ background: colors.cell, padding: '4px 8px', margin: '2px' }}>{signal.data.enrichment?.ipdata?.emoji_flag}</td>
                <td style={{ background: colors.cell, padding: '4px 8px', margin: '2px' }}>{signal._m.c && moment(signal._m.c.toDate()).fromNow()}</td>
                <td style={{ background: hasImpossibleTravel ? colors.critical : colors.normal, padding: '4px 8px', margin: '2px' }}>{hasImpossibleTravel ? 'fail' : 'ok'}</td>
                <td style={{ background: hasIpSimilarity ? colors.warning : colors.normal, padding: '4px 8px', margin: '2px' }}>{hasIpSimilarity ? 'fail' : 'ok'}</td>
              </tr>
            );
          }
          )}
        </tbody>
      </table>
    </div>
  );
}

const container = document.getElementById('app');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container);
root.render(<App />);
